import {
  GROWTHBOOK_FLAGS,
  GrowthBookUtils,
  init,
  WHITELISTED_DEFAULT_VALUE
} from '@mafc/common'

export const isServer = () => typeof window === 'undefined'
export function watch(
  obj: any,
  prop: string,
  notifier: (prop: string, oldVal: any, newVal: any) => void
) {
  let old = obj[prop]
  let cur = old
  const getter = function () {
    return cur
  }
  const setter = function (val: any) {
    old = cur
    cur = val
    notifier.call(obj, prop, old, val)
    return val
  }
  // can't watch constants
  if (delete obj[prop]) {
    Object.defineProperty(obj, prop, {
      get: getter,
      set: setter,
      enumerable: true,
      configurable: true
    })
  }
}

export const setGrowthBookFlagsInRedux = (store: any) => {
  const adtechSLP = GrowthBookUtils.getGrowthBookFeatureValueViaInstance(
    store?.getState(),
    GROWTHBOOK_FLAGS.adtech_slp
  )?.on

  const posInfoConfig =
    GrowthBookUtils.getGrowthBookFeatureValueViaInstance(
      store?.getState(),
      GROWTHBOOK_FLAGS.common_whitelisted_service_type_config
    )?.value || []

  const adtechPLP = GrowthBookUtils.getGrowthBookFeatureValueViaInstance(
    store?.getState(),
    GROWTHBOOK_FLAGS.adtech_plp
  )?.on
  const nonFoodUIDs =
    GrowthBookUtils.getGrowthBookFeatureValueViaInstance(
      store?.getState(),
      GROWTHBOOK_FLAGS.non_food_v2
    )?.value || {}

  const addressNewJourney = GrowthBookUtils.getGrowthBookFeatureValueViaInstance(
    store?.getState(),
    GROWTHBOOK_FLAGS.address_new_journey
  )?.on

  const posInfoConfigState =
    posInfoConfig.length === 0 ? WHITELISTED_DEFAULT_VALUE : posInfoConfig
  store.dispatch(
    init({
      adtech_slp: adtechSLP,
      adtech_plp: adtechPLP,
      posInfoConfig: posInfoConfigState,
      nonFoodUIDs,
      addressNewJourney
    })
  )
}
